/**
 * 业务状态码
 */
export const enum BizCode {
  /**
   * 成功
   * @type {String}
   */
  SUCCESS = '0000',
  /**
   * 未授权
   * @type {String}
   */
  UNAUTHORIZED = '0001',
}
